<template>
  <div>
    <h3 class="heading-3 weight-medium pb-10 pb-md-16 text-left text-md-center">
      Select Your Current Source of Income
    </h3>

    <div class="input-box-holder mb-10" v-validate="errors" v-has-value="person.income">
      <div class="validation-output text-left mb-10">
        <ErrorHandler class="error" :id="`V046_${index}`">
          You have not selected any of the options. To continue, please select one option.
        </ErrorHandler>
      </div>

      <EmployeePackage
        :income="person.income"
        :index="index"
        :errors="errors"
      />

      <CompanyPackage
        :income="person.income"
        :index="index"
        :errors="errors"
      />

      <OtherPackage
        :income="person.income"
        :life-situation="person.lifeSituation"
        :index="index"
        :errors="errors"
      />

      <UnemployedPackage
        :income="person.income"
        :life-situation="person.lifeSituation"
        :model="model"
        :index="index"
        :errors="errors"
      />
    </div>
  </div>
</template>

<script>
import EmployeePackage from '@/pagesComponents/IncomeSourceComponents/EmployeePackage.vue';
import CompanyPackage from '@/pagesComponents/IncomeSourceComponents/CompanyPackage.vue';
import OtherPackage from '@/pagesComponents/IncomeSourceComponents/OtherPackage.vue';
import UnemployedPackage from '@/pagesComponents/IncomeSourceComponents/UnemployedPackage.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  components: {
    UnemployedPackage,
    OtherPackage,
    CompanyPackage,
    EmployeePackage,
    ErrorHandler,
  },
  props: {
    person: { type: Object, required: true },
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
};
</script>
